"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformAccountSettings = void 0;
var pick_1 = __importDefault(require("lodash/pick"));
var allowedFields = [
    "globalSubstitutions",
    "notifications",
    "brand",
    "stylePermissions",
    "customDomainHasUpdatedDns",
];
var transformAccountSettings = function (settingsData) {
    return (0, pick_1.default)(settingsData, allowedFields);
};
exports.transformAccountSettings = transformAccountSettings;
